export const CATEGORY_COLOR = {
  roas: '#85da47',
  cost: '#000000',
  imp: '#1C304A',
  click: '#046B99',
  conv: '#00CFFF',
  convValue: '#B3EFFF',
};

export const CATEGORY_NAME = {
  roas: 'ROAS',
  cost: '광고비',
  imp: '노출수',
  click: '클릭수',
  conv: '전환수',
  convValue: '매출',
};
